import { TaxCertificate } from './tax-certificate.interface';
import { TaxCertificateService } from './tax-certificate.service';

const service = new TaxCertificateService();

export interface TaxCertificateState {
   taxCertificates: Array<TaxCertificate>;
}

const state: TaxCertificateState = {
   taxCertificates: [],
};

const getters = {
   taxCertificates(state: TaxCertificateState) {
      return state.taxCertificates;
   },
};

const mutations = {
   SET_TAX_CERTIFICATES(state: TaxCertificateState, taxCertificates: Array<TaxCertificate>) {
      state.taxCertificates = taxCertificates;
   },
};

const actions = {
   async getTaxCertificates(context: any) {
      return await service.getTaxCertificates().then((response) => {
         context.commit('SET_TAX_CERTIFICATES', response);
         return response;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};
